import NotFoundTemplate from './NotFoundTemplate';
export default NotFoundTemplate;
